import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from './media-query';
export var useScreenSize = function useScreenSize() {
  var _useContext = useContext(ThemeContext),
      screen = _useContext.screen; // Mobile


  var isMobileQuery = "(max-width: ".concat(screen === null || screen === void 0 ? void 0 : screen.smMax, ")");

  var _useMediaQuery = useMediaQuery(isMobileQuery),
      isMobile = _useMediaQuery.matches; // Tablet portrait


  var isTabletPortraitQuery = "(min-width: ".concat(screen === null || screen === void 0 ? void 0 : screen.mdMin, ") and (max-width: ").concat(screen === null || screen === void 0 ? void 0 : screen.mdMax, ")");

  var _useMediaQuery2 = useMediaQuery(isTabletPortraitQuery),
      isTabletPortrait = _useMediaQuery2.matches; // Tablet landscape


  var isTabletLandscapeQuery = "(min-width: ".concat(screen === null || screen === void 0 ? void 0 : screen.lgMin, ") and (max-width: ").concat(screen === null || screen === void 0 ? void 0 : screen.lgMax, ")");

  var _useMediaQuery3 = useMediaQuery(isTabletLandscapeQuery),
      isTabletLandscape = _useMediaQuery3.matches; // Desktop


  var isDesktopQuery = "(min-width: ".concat(screen === null || screen === void 0 ? void 0 : screen.xlMin, ")");

  var _useMediaQuery4 = useMediaQuery(isDesktopQuery),
      isDesktop = _useMediaQuery4.matches;

  return {
    isMobile: isMobile,
    isTabletPortrait: isTabletPortrait,
    isTabletLandscape: isTabletLandscape,
    isDesktop: isDesktop
  };
};